module.exports = __webpack_public_path__ + "media/components/assets/icons/message-bc314c09b4a1d9c89967b6265c9b8ad3.svg";